import React from 'react';

// A planner bookmark carries Plannely's teal outline and coral check.
export default function SectionLabel({ children }) {
  return <div className="eyebrow">
    <svg className="section-bookmark" viewBox="0 0 28 34" aria-hidden="true" focusable="false">
      <path className="bookmark-paper" d="M4 5h15a2 2 0 0 1 2 2v23l-8.5-4L4 30V5Z" />
      <path className="bookmark-check" d="m8 13 5 5L25 5" />
    </svg>
    <span className="section-label-text">{children}</span>
  </div>;
}
